import { render, staticRenderFns, recyclableRender, components } from "./qualification.vue?vue&type=template&id=57d96ab9&scoped=true&"
var renderjs
import script from "./qualification.vue?vue&type=script&lang=js&"
export * from "./qualification.vue?vue&type=script&lang=js&"
import style0 from "./qualification.vue?vue&type=style&index=0&id=57d96ab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d96ab9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/qualification/qualification.vue"
export default component.exports